import React, { Fragment, useState, useEffect, useRef } from 'react'
import { useStore } from '@nanostores/react'
import { userData } from '@stores/userStore'
import { cartData } from '@stores/cartStore'
import { isMobileMenuOpen } from '@stores/menuStore'
import { isSearchOpen } from '@stores/searchStore'
import User from '@components/Icons/User.jsx'
import UserSolid from '@components/Icons/UserSolid.jsx'
import UserCircle from '@components/Icons/UserCircle.jsx'
import Gift from '@components/Icons/Gift.jsx'
import OpenBox from '@components/Icons/OpenBox'
import Person from '@components/Icons/Person.jsx'
import { registryData } from '@stores/registryStore'
import { chord } from '@api/chord.js'
import { simulateClick } from '@utils/utils.js'
import { updateCartDiscountCodes, getCart } from '@api/shopify'

const NavAccountMobile = () => {
    const $userData = useStore(userData || null)
    const $isMobileMenuOpen = useStore(isMobileMenuOpen)
    const [haveUser, setHaveUser] = useState(false)
    const [show, setShow] = useState(false)
    const [hasRegistry, setHasRegistry] = useState(false)
    const ref = useRef(null)

    //

    /* prevents flash of unlogged-in user in nav */
    useEffect(() => {
        if ($userData && $userData.email) {
            setHaveUser(true)
        } else {
            setHaveUser(false)
        }
    }, [$userData])

    useEffect(() => {
        const handleOutSideClick = (event) => {
            if (!ref.current?.contains(event.target)) {
                setShow(false)
            }
        }

        window.addEventListener('mousedown', handleOutSideClick)

        return () => {
            window.removeEventListener('mousedown', handleOutSideClick)
        }
    }, [ref])

    useEffect(() => {
        if (localStorage.getItem('hasRegistry') === 'true') {
            setHasRegistry(true)
        } else {
            setHasRegistry(false)
        }
    }, [])

    const handleNavAccountClick = () => {
        setShow(!show)

        const main = document.querySelector('main')
        main.classList.remove('menu-overlay')
        const menuClose = document.querySelector('.menu-close')
        if ($isMobileMenuOpen) {
            simulateClick(menuClose)
        }

        isSearchOpen.set(false)
    }

    // Helper function to check if a discount code is from Inveterate
    const isInveterateDiscountCode = (code) => {
        return code && code.startsWith('REDEEM+');
    };

    // Remove Inveterate discount codes from cart
    const removeInveterateDiscounts = async () => {
        const currentCartData = cartData.get();

        if (!currentCartData?.cartId || !currentCartData?.discountCodes) {
            console.log('No cart data or discount codes to remove');
            return;
        }

        console.log('Removing Inveterate discounts on logout...');

        // Filter out Inveterate discount codes
        const nonInveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && !isInveterateDiscountCode(dc.code))
            .map(dc => dc.code);

        const inveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && isInveterateDiscountCode(dc.code));

        if (inveterateDiscounts.length > 0) {
            console.log('Found Inveterate discount codes to remove on logout:', inveterateDiscounts.map(dc => dc.code));

            try {
                // Update cart with only non-Inveterate discount codes
                const discountResult = await updateCartDiscountCodes(currentCartData.cartId, nonInveterateDiscounts);

                if (discountResult.body?.cartDiscountCodesUpdate?.cart) {
                    const updatedCart = discountResult.body.cartDiscountCodesUpdate.cart;

                    console.log('Successfully removed Inveterate discounts on logout');

                    // Update cart store with new data
                    const cartObj = {
                        ...currentCartData,
                        cost: updatedCart.cost,
                        lines: updatedCart.lines.edges,
                        discountCodes: updatedCart.discountCodes,
                        discountAllocations: updatedCart.discountAllocations,
                    };

                    cartData.set(cartObj);
                }
            } catch (error) {
                console.error('Failed to remove Inveterate discount codes on logout:', error);
            }
        } else {
            console.log('No Inveterate discount codes found in cart on logout');
        }
    };

    const handleLogout = async () => {
        console.log('Logout initiated - clearing user data and removing Inveterate discounts...');

        // Remove Inveterate discounts before clearing user data
        await removeInveterateDiscounts();

        // Clear user data
        userData.set({});
        registryData.set({});
        localStorage.removeItem('ma_user');
        chord.reset();
        localStorage.setItem('hasRegistry', 'false');
        document.cookie =
            'access_token=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'
        document.cookie =
            'ma_registry_id=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'
        localStorage.removeItem('registry_token')
        localStorage.removeItem('registryId')

        console.log('Logout completed - user data cleared and Inveterate discounts removed');

        setTimeout(() => {
            window.location.href = '/'
        }, 1000)
    }

    return (
        <div className="account-wrap h-full" ref={ref}>
            <div className="nav-account-outer mr-2 relative flex items-center justify-center h-full">
                <div
                    className="nav-account-inner h-full cursor-pointer"
                    onClick={handleNavAccountClick}
                >
                    {haveUser ? (
                        <a href="/account">
                            <UserSolid width="w-[20px]" />
                        </a>
                    ) : (
                        <a href="/account/login">
                            <UserCircle width="w-[20px]" />
                        </a>
                    )}
                </div>
            </div>

        </div>
    )
}

export default NavAccountMobile

{
    /*}{% if customer.metafields.baby_registry.registry_availability == "True" %}
                            <a href="/pages/registry" className="nav-utility-registry">Your Registry</a>
                        {% else %}
                            <a href="/pages/m-a-registry" className="nav-utility-registry">Start a Registry</a>
                        {% endif %}
                        */
}
